<template>
    <div style="display: flex;flex-direction: column;">
        <div v-for="url in urls" :key="url">
            <video muted autoplay loop class="gpt-chart-video">
                <source :src="url" type="video/mp4" />
            </video>
        </div>
        <div>{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: 'gpt-chart-video',
    props: {
        value: {
            type: String
        },
        text: {
            type: String
        }
    },
    computed: {
        urls () {
            return this.value.split(',');
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-chart-video {
    width: 100%;
    height: 100%;
    object-fit: fill;
}
</style>
